import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cx from 'classnames';
import { trackEvent } from '../../utils/analytics';
import Svg from '../Svg';
import s from './InfoModal.module.scss';

const propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  toggleModal: PropTypes.func,
  bumper: PropTypes.bool,
  eventName: PropTypes.string,
  location: PropTypes.string,
  ctaText: PropTypes.string,
  className: PropTypes.string,
  secondaryCloseBtn: PropTypes.bool,
  closeBtnColor: PropTypes.string,
  autoSize: PropTypes.bool,
};

// Accessibility: get the main app element to properly
// hide when the modal is active, for screen readers.
const InfoModal = ({
  isOpen = false,
  children,
  toggleModal = () => {},
  bumper = false,
  eventName = '',
  location = '',
  ctaText = 'X',
  className = '',
  secondaryCloseBtn = false,
  closeBtnColor = '#757575',
  autoSize = false,
}) => {
  const appElement = document.getElementById('__next');
  return (
    <Modal
      isOpen={isOpen}
      overlayClassName={s.overlay}
      onRequestClose={toggleModal}
      appElement={appElement}
      className="modal"
    >
      <div
        data-testid="infoModal"
        className={[
          cx(className, s.innerModal, bumper ? s.bumper : '', autoSize ? s.autoSize : ''),
        ].join(' ')}
      >
        <button
          className={secondaryCloseBtn ? s.secondaryChildCloseButton : s.childCloseButton}
          type="button"
          onClick={() => {
            if (location) trackEvent(eventName, { location, cta_text: ctaText });
            toggleModal();
          }}
          title="Close"
        >
          {!secondaryCloseBtn && (
            <Svg
              icon="close_thin"
              height="32"
              width="32"
              color={closeBtnColor}
              viewBox="0 0 32 32"
            />
          )}
          {secondaryCloseBtn && (
            <Svg icon="close" height="24" width="24" color={closeBtnColor} viewBox="0 0 24 24" />
          )}
        </button>
        {children}
      </div>
    </Modal>
  );
};

InfoModal.propTypes = propTypes;
export default InfoModal;
